import React from 'react';
import BaseModalComponent, {
  StyledBaseModal,
  StyledBaseModalContent,
} from './BaseModal.component';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CardComponent, { StyledCard } from '../Card.component';
import LogoGrayIcon from '../Icons/Logo/LogoGray.icon';
import ComputerSleepIcon from '../Icons/Computer/ComputerSleep.icon';
import SpinnerComponent from '../Spinner.component';

const StyledNetworkErrorModalBGIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.BG1};
  border-radius: 8px;
`;
const StyledNetworkErrorModalBody = styled.div`
  & > ${StyledCard} {
    width: 520px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;
    justify-content: center;
  }
`;
const StyledNetworkErrorModalDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  color: ${({ theme }) => theme.colors.LABEL};
  font-weight: 500;
`;
const StyledNetworkErrorModalTitle = styled.div`
  color: ${({ theme }) => theme.colors.TITLE};
  font-size: 24px;
  font-weight: 500;
`;
const StyledNetworkErrorHeaderTitle = styled.div`
  color: ${({ theme }) => theme.colors.TITLE};
  font-size: 24px;
  font-weight: 500;
`;
const StyledNetworkErrorHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;
const StyledNetworkErrorModal = styled.div`
  ${StyledBaseModal} > ${StyledCard} {
    background: ${({ theme }) => theme.colors.BG_SPLASH};
  }
  ${StyledBaseModalContent} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 45px;
    width: 100vw;
    height: 100vh;
    max-height: fit-content;
  }
`;

const LOGO_ICON_SIZE = 32;
const ERROR_MODAL_ICON_SIZE = 180;

const PersonSoftDuplicateModalComponent = () => {
  const { t } = useTranslation();

  return (
    <StyledNetworkErrorModal>
      <BaseModalComponent isBlocked={true}>
        <StyledNetworkErrorHeader>
          <LogoGrayIcon width={LOGO_ICON_SIZE} height={LOGO_ICON_SIZE} />
          <StyledNetworkErrorHeaderTitle>Hunter</StyledNetworkErrorHeaderTitle>
        </StyledNetworkErrorHeader>
        <StyledNetworkErrorModalBody>
          <CardComponent>
            <StyledNetworkErrorModalBGIcon>
              <ComputerSleepIcon width={ERROR_MODAL_ICON_SIZE} height={ERROR_MODAL_ICON_SIZE} />
            </StyledNetworkErrorModalBGIcon>
            <StyledNetworkErrorModalTitle>
              {t('Network error')}
            </StyledNetworkErrorModalTitle>
            <StyledNetworkErrorModalDescription>
              <div>
                {t('Attempt to restore communication with the server...')}
              </div>
              <SpinnerComponent />
            </StyledNetworkErrorModalDescription>
          </CardComponent>
        </StyledNetworkErrorModalBody>
      </BaseModalComponent>
    </StyledNetworkErrorModal>
  );
};

export default PersonSoftDuplicateModalComponent;
